export default {
  "0": "0",
  "1": "1px",
  "2": "2px",
  "4": "4px",
  "5": "5px",
  "8": "8px",
};
